import { makeStyles, Theme } from '@material-ui/core';

export const useStyles = makeStyles(({ palette }: Theme) => ({
  icon: {
    fill: palette.primary.main,
  },
  controlWrapper: {
    flexWrap: 'wrap',
  },
  text: {
    fontSize: 12,
    lineHeight: '19px',
    flexBasis: '100%',
  },
  textField: {},
}));
